import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryArrowIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9346 9.99999L8.99974 15.9348L14.9346 21.8696"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M24 16.058H9.61182" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
